import React from "react";

const serviceCards = [
  {
    id: "individual-family",
    title: "Individual & Family Health Insurance",
    body: "Compare major medical plans, private health insurance options, GigCare coverage, and supplemental benefits for individuals and families. I'll explain how each plan works, what it covers, and what you can expect to pay when you use it.",
  },
  {
    id: "self-employed-small-business",
    title: "Self-Employed & Small Business Coverage",
    body: "Health insurance solutions for freelancers, independent contractors, sole proprietors, and small businesses. Compare individual, group, and GigCare options designed to help business owners and their teams access quality healthcare without sorting through the fine print alone.",
  },
  {
    id: "coverage-for-life-changes",
    title: "Coverage for Life Changes",
    body: "Turning 26, leaving a job, losing employer coverage, starting college, moving, or considering COBRA? I'll help you understand your enrollment options, deadlines, costs, provider networks, and available coverage before you make a decision.",
  },
];

const ServicesOverview = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-4xl mb-16">
          <span className="text-sm font-semibold text-[#3A7D44] uppercase tracking-wider">
            Services
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1B2A1B] mt-4 mb-5 leading-tight"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Health Insurance Solutions for Every Stage of Life
          </h2>
          <p className="text-[#5A6B5A] leading-relaxed text-lg max-w-3xl">
            Whether you need coverage for yourself, your family, your business,
            or a change in circumstances, I help you compare health insurance
            options from multiple carriers. We'll look at your healthcare needs,
            preferred doctors, prescriptions, and budget so you can choose
            coverage with confidence.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {serviceCards.map((card) => (
            <div
              key={card.id}
              data-testid={`service-card-${card.id}`}
              className="bg-[#F9F7F4] rounded-t-2xl p-8 lg:p-10 border-t-2 border-[#1B2A1B] hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-bold text-[#1B2A1B] mb-5">
                {card.title}
              </h3>
              <p className="text-[#5A6B5A] leading-relaxed">
                {card.body}
              </p>
            </div>
          ))}
        </div>

        {/* AEO block */}
        <div className="mt-16 pt-10 border-t border-gray-100 max-w-4xl">
          <h3
            className="text-2xl sm:text-3xl font-bold text-[#1B2A1B] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            What Types of Health Insurance Do You Offer?
          </h3>
          <p className="text-[#5A6B5A] leading-relaxed text-lg">
            Hess Insurance Solutions helps individuals, families, self-employed
            professionals, and small businesses compare major medical health
            insurance, GigCare plans, private coverage, and supplemental
            benefits. Available options depend on your location, eligibility,
            healthcare needs, and budget.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
